import {Component, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
    selector: 'app-doc-tax-invoice',
    templateUrl: './doc-tax-invoice.component.html',
    styleUrls: ['./doc-tax-invoice.component.scss'],
    standalone: false
})
export class DocTaxInvoiceComponent implements OnInit {
  // relative (no leading slash) so it resolves against <base href> at runtime,
  // and bound via [href] since a static href="..." on a stylesheet <link> is
  // treated by Angular's AOT compiler as a build-time resource path.
  printCssHref: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    this.printCssHref = this.sanitizer.bypassSecurityTrustResourceUrl('assets/css/print.css');
  }

  ngOnInit(): void {
  }

}
